export class ApiList {
  static start() {
    const $elements = $('.api-list');

    if ($elements) {
      $elements.each(function init_api_lists() {
        const $element = $(this);

        $element.data('apilist', new ApiList($element));
      });
    }
  }

  constructor($element) {
    this.$element = $element;

    this.bind_events();
  }

  bind_events() {
    this.$element.on('click', '.api-versions button', (event) => this.handle_version_change(event));
  }

  // eslint-disable-next-line class-methods-use-this
  handle_version_change(event) {
    const $element = $(event.currentTarget);
    const $parent = $element.parents('.card[data-api]');

    // const api = $parent.data('api');
    const version = $element.data('version');

    $element.addClass('active');
    $element.siblings().removeClass('active');

    $parent.find('.api-urls').addClass('d-none');
    $parent.find(`.api-urls[data-version="${version}"]`).removeClass('d-none');
  }
}
